module.exports = __webpack_public_path__ + "img/outlander2022_power.a0ce124e.jpg";